export const CLASS_TYPES = [
  { key: 'Economy', value: 'Economy' },
  { key: 'Business', value: 'Business' },
];

export const PUBLIC_OFFICIAL = [
  { key: 'No', value: 'No' },
  { key: 'Yes', value: 'Yes' },
];

export const COST_SUMMARY = [
  { key: 'FlightQuoteCost', value: 'Flight Quote', type: 'number' },
  { key: 'FlightCost', value: 'Flight Actual', type: 'number' },
  { key: 'FlightVendor', value: 'Flight Vendor', type: 'string' },
  { key: 'HotelQuoteCost', value: 'Hotel Quote', type: 'number' },
  { key: 'HotelCost', value: 'Hotel Actual', type: 'number' },
  { key: 'HotelVendor', value: 'Hotel Vendor', type: 'string' },
  {
    key: 'InsuranceQuoteCost',
    value: 'Travel Insurance Quote',
    type: 'number',
  },
  { key: 'InsuranceCost', value: 'Travel Insurance Actual', type: 'number' },
  {
    key: 'TravelInsuranceVendor',
    value: 'Travel Insurance Vendor',
    type: 'string',
  },
  {
    key: 'AirportTransferQuoteCost',
    value: 'Airport Transfer Quote',
    type: 'number',
  },
  {
    key: 'AirportTransferCost',
    value: 'Airport Transfer Actual',
    type: 'number',
  },
  {
    key: 'AirTransferVendor',
    value: 'Airport Transfer Vendor',
    type: 'string',
  },
  { key: 'VisaQuoteCost', value: 'Visa Quote', type: 'number' },
  { key: 'VisaCost', value: 'Visa Actual', type: 'number' },
  { key: 'VisaVendor', value: 'Visa Vendor', type: 'string' },
  { key: 'tqc', value: 'Total Quote Cost', type: 'number' },
  { key: 'tac', value: 'Total Actual Cost', type: 'number' },
];
